import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { target: String }

  connect() {
    const modal = document.getElementById(this.targetValue)
    if (modal) bootstrap.Modal.getOrCreateInstance(modal).show()
  }
}
